export {
  type AppGraphemePronunciationCard,
  appGraphemePronunciationCardTable,
} from "#app-grapheme-pronunciation-card-table";
